/*
  Миксин с сокетами для акшенов на странице админки модуля
*/

import {Component, Vue, Prop} from 'vue-property-decorator';
import {connectionPModuleActions} from '@/api/configApi';
import {PModuleWithMeasurements} from '@/views/system/modules/interfaces';
import {PMActionType} from '@/views/system/modules/enums';

@Component
export default class ModuleDeveloperActionMixin extends Vue {
  // Программный модуль
  @Prop()
  pmodule!: PModuleWithMeasurements;
  // Веб сокет
  private socket!: WebSocket | null;

  actionType!: PMActionType;

  protected result: any = null;

  async created() {
    this.openWS();
  }

  protected async sendAction(callback: any) {
    await callback();
  }

  beforeDestroy() {
    this.closeWS();
  }

  // Закрыть соединения веб сокета
  closeWS() {
    if (this.socket) {
      this.socket.close();
      this.socket = null;
    }
  }

  // Открыть вебсокет
  openWS() {
    if (!this.pmodule.guid) return;
    this.socket = connectionPModuleActions(this.pmodule.guid, this.actionType);
    this.socket.onmessage = (e: any) => this.subscribeConectionWS(e);
  }

  //Действия на веб сокете
  subscribeConectionWS(e: {data: string}) {
    this.result = e.data;
  }
}
